import Vue from 'vue'
import moment from 'moment'

export default function (app) {
  moment.locale('en')
  window.moment = app.$moment = moment
  Vue.use(() => {
    Object.defineProperties(Vue.prototype, {
      $moment: {
        get () {
          return moment
        }
      }
    })
  })
}
